import { Bold, Heading, List } from "lucide-react";
import { spooky } from "@/components/halloween/spooky";

const bold = (line, k) => line.split(/\*\*(.+?)\*\*/g).map((part, i) => (i % 2 ? <strong key={`${k}-${i}`} className="font-extrabold text-slate-900">{spooky(part, `${k}-${i}`)}</strong> : spooky(part, `${k}-${i}`)));

const isItem = (l) => /^[-•] /.test(l);

export function RichText({ text, id }) {
  const blocks = [];
  text.split("\n").forEach((l, i) => {
    if (isItem(l)) {
      const last = blocks[blocks.length - 1];
      if (last?.list) last.items.push([i, l.slice(2)]); else blocks.push({ list: true, i, items: [[i, l.slice(2)]] });
    } else blocks.push({ i, l });
  });
  return (
    <div className="text-[15px] leading-relaxed break-words" data-testid={`post-text-${id}`}>
      {blocks.map((b) => (b.list
        ? <ul key={b.i} className="my-1.5 space-y-1" data-testid={`post-list-${id}-${b.i}`}>
            {b.items.map(([k, t]) => <li key={k} className="flex gap-2.5"><span className="mt-[0.55em] w-2 h-2 rounded-full bg-gradient-to-br from-rose-400 to-fuchsia-500 shrink-0" aria-hidden /><span className="min-w-0">{bold(t, k)}</span></li>)}
          </ul>
        : b.l.startsWith("## ")
          ? <h3 key={b.i} className="font-display text-lg font-extrabold text-rose-600 mt-3 first:mt-0 mb-1" data-testid={`post-heading-${id}-${b.i}`}>{bold(b.l.slice(3), b.i)}</h3>
          : <p key={b.i} className="whitespace-pre-wrap min-h-[1em]">{bold(b.l, b.i)}</p>))}
    </div>
  );
}

export const stripMarks = (t) => t.replace(/\*\*(.+?)\*\*/g, "$1").replace(/^(## |- )/gm, "");

export function FormatButtons({ inputRef, value, onChange }) {
  const apply = (kind) => {
    const el = inputRef.current;
    const s = el?.selectionStart ?? value.length, e = el?.selectionEnd ?? value.length;
    let next, caret;
    if (kind === "bold") {
      const sel = value.slice(s, e) || "fetter Text";
      next = `${value.slice(0, s)}**${sel}**${value.slice(e)}`; caret = s + sel.length + 4;
    } else {
      const mark = kind === "list" ? "- " : "## ";
      const ls = value.lastIndexOf("\n", s - 1) + 1;
      const has = value.startsWith(mark, ls);
      next = has ? value.slice(0, ls) + value.slice(ls + mark.length) : `${value.slice(0, ls)}${mark}${value.slice(ls)}`; caret = has ? s - mark.length : s + mark.length;
    }
    onChange(next);
    requestAnimationFrame(() => { el?.focus(); el?.setSelectionRange(caret, caret); });
  };
  const cls = "inline-flex items-center justify-center w-10 h-10 rounded-full text-rose-600 hover:bg-rose-50";
  return (
    <>
      <button type="button" onClick={() => apply("bold")} title="Fett (**Text**)" aria-label="Fett" data-testid="composer-format-bold" className={cls}><Bold className="w-5 h-5" /></button>
      <button type="button" onClick={() => apply("heading")} title="Zwischenüberschrift (## am Zeilenanfang)" aria-label="Zwischenüberschrift" data-testid="composer-format-heading" className={cls}><Heading className="w-5 h-5" /></button>
      <button type="button" onClick={() => apply("list")} title="Aufzählungspunkt (- am Zeilenanfang)" aria-label="Aufzählung" data-testid="composer-format-list" className={cls}><List className="w-5 h-5" /></button>
    </>
  );
}
